import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';

import {useUsageEvents} from '../hooks/useUsageEvents.ts';

export const ReloadRecordsButton = () => {

    const {reload} = useUsageEvents();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => reload()}/>
        </Box>
    );
};
